import React from 'react'
import PropTypes from 'prop-types'

import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group'
import { Route, Switch } from 'react-router-dom'

const TransitionSwitch = ({ children, classNames, timeout }) => (
  <Route render={({location}) => (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        timeout={timeout}
        classNames={classNames}>
        <Switch location={location}>
          {children}
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  )}
  />
)

TransitionSwitch.defaultProps = {
  timeout: 300,
  classNames: 'fade',
}

TransitionSwitch.propTypes = {
  children: PropTypes.any,
  timeout: PropTypes.number,
  classNames: PropTypes.string,
}

export default TransitionSwitch



// WEBPACK FOOTER //
// ./src/containers/TransitionSwitch.js